import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Footer = () => {
    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    {/* <div className="d-flex">
                        <div>
                            <button className="btn btn-primary shadow-lg rounded">Previous</button>
                        </div>
                        <div className="ms-auto">
                            <button className="btn btn-info shadow-lg rounded">Draft & Exit</button>
                            <button className="btn  btn-danger shadow-lg rounded ms-2">Cancel</button>
                            <button className="btn btn-secondary shadow-lg rounded ms-2">Next</button>
                        </div>
                    </div> */}
                </Container>
            </footer>
        </React.Fragment>
    )
}

export default Footer;